import { render, staticRenderFns } from "./LeadsTableItem.vue?vue&type=template&id=cefeeeb6&scoped=true"
import script from "./LeadsTableItem.vue?vue&type=script&lang=js"
export * from "./LeadsTableItem.vue?vue&type=script&lang=js"
import style0 from "./LeadsTableItem.vue?vue&type=style&index=0&id=cefeeeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefeeeb6",
  null
  
)

export default component.exports